import React from 'react';

import { EluveNameLogo, Stack } from '@eluve/components';

import { useInterstitials } from './hooks/useInterstitials';

export const InterstitialOverlay: React.FC = () => {
  const { activeInterstitial, isLoading, context } = useInterstitials();

  if (!activeInterstitial || isLoading || !context) {
    return null;
  }

  const FlowComponent = activeInterstitial.component;

  if (activeInterstitial.transparentBackground) {
    return (
      <Stack
        className="fixed inset-0 z-50"
        role="dialog"
        aria-modal="true"
        aria-labelledby="interstitial-title"
        gap={2}
      >
        <FlowComponent context={context} />
      </Stack>
    );
  }

  return (
    <Stack
      className="fixed inset-0 z-50 bg-bg-secondary p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="interstitial-title"
      gap={10}
      align="center"
      justify="center"
    >
      <EluveNameLogo className="h-16" />
      <Stack className="mx-auto size-fit rounded-xl bg-white shadow-sm" gap={2}>
        <FlowComponent context={context} />
      </Stack>
    </Stack>
  );
};
